/** @jsx jsx */
import React, { useCallback } from 'react';
import { css, jsx } from '@emotion/core';

import { textFontSize, utilityColor, grayScale } from 'components/styles';
import Icon from 'components/atoms/Icon';
import BodyText from 'components/atoms/BodyText';


const styles = {
  wrapper: css({
    width: '100%',
    margin: '16px 0 16px 0',
  }),
  content: css({
    display: 'block',
    marginBottom: '15px',
    backgroundColor: utilityColor.white,
    border: `1px solid ${grayScale.gray20}`,
  }),
  button: css({
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
    padding: '15px 0px',
    fontFamily: 'inherit',
    text: textFontSize.re,
    minWidth: '140px',
    width: '100%',
    textAlign: 'left',
    backgroundColor: '#22AEE5',
    display: 'flex',
    alignItems: 'center',
    borderRadius:'3px',
  }),
  hidden: css({
    display: 'none',
  }),
  label: css({
    color: 'white',
    fontWeight: 'bold',
  }),
};

interface AccordionProps {
  text: string;
  color?: string;
  defaultExpand?: boolean;
  callBack: () => void;
}

const Accordion: React.FC<AccordionProps> = ({
  children, text, color="#FFFFFF", defaultExpand = false, callBack,
}) => {
  const [isExpand, setExpand] = React.useState(defaultExpand);


  const onClick = useCallback(() => {
    setExpand(!isExpand);
    callBack(); 
  }, [callBack, isExpand]);

  return (
    <React.Fragment>
      <div css={css(styles.wrapper)}>
        <button type="button" css={styles.button} onClick={onClick}>
          {
          isExpand
            ? <Icon type="chevronUp" color={color} size="15px" margin="0 20px 0 15px" verticalAlign="middle" />
            : <Icon type="chevronDown" color={color} size="15px" margin="0 20px 0 15px" verticalAlign="middle" />
        }
          <BodyText size="re" customStyle={styles.label} >{text}</BodyText>
        </button>

        <div css={css(styles.content, !isExpand ? styles.hidden : '')}>
          {children}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Accordion;
